<template>
  <div
    v-if="items.length"
    class="bg-white border border-neutral-300 dark:bg-neutral-800/50 dark:border-neutral-600 rounded-md overflow-hidden"
  >
    <div class="px-4 py-3 font-semibold text-neutral-950 dark:text-neutral-100 border-b border-neutral-200 dark:border-neutral-700">
      {{ i18N('gamification.itemCompetitions', { count: items.length }, items.length) }}
    </div>

    <!-- Linha de altura fixa: a partir da 4ª competição a lista rola, sem esticar o bloco -->
    <div class="max-h-[170px] overflow-y-auto custom-scrollbar divide-y divide-neutral-200 dark:divide-neutral-700">
      <div
        v-for="item in items"
        :key="item.id"
        class="h-14 flex items-center justify-between gap-4 px-4"
      >
        <!--
          @TODO: navegar para a competição quando a rota estiver confirmada. Como a tela de
          detalhe é um modal, ao navegar também é preciso fechá-lo (emitir para o pai).
        -->
        <button
          type="button"
          class="flex-1 min-w-0 block text-left text-sm font-semibold text-violet-600 dark:text-violet-400 underline underline-offset-2 hover:opacity-80 truncate"
          v-tooltip="{ text: item.name, width: 'auto', ifTruncated: true }"
        >{{ item.name }}</button>

        <div class="shrink-0 flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-bold text-white" :class="item.earned ? 'bg-emerald-600' : 'bg-violet-600'">
          <UiIcon v-if="item.earned" icon="circle-check" size="16" />
          <img v-else src="/img/game/bolt.svg?url" width="16" height="16" alt="" />
          {{ item.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { i18N, competitionPoints } from '@/common/util'

import UiIcon from '@/components/ui/icon.vue'

import type { CompetitionGamification } from '@/types/types'

const { competitions } = defineProps<{
  competitions?: CompetitionGamification[] | null
}>()

const items = computed(() => competitionPoints(competitions))
</script>

<style scoped>
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: rgba(156, 163, 175, 0.5);
  border-radius: 20px;
}
.dark .custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.1);
}
</style>
